import React from "react";
import Layout from "../layouts";

export default function Dashboard() {
  const tabs = [
    { label: "Overview", key: "overview", content: <div>Overview content</div> },
    { label: "Analytics", key: "analytics", content: <div>Analytics content</div> },
    { label: "Settings", key: "settings", content: <div>Settings content</div> },
  ];
  return (
    <Layout pageTitle="Dashboard" tabs={tabs}>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white shadow-md rounded-lg p-4">
          <h2 className="text-lg font-semibold text-gray-700">Total Users</h2>
          <p className="text-2xl font-bold text-blue-600">1,245</p>
        </div>
        <div className="bg-white shadow-md rounded-lg p-4">
          <h2 className="text-lg font-semibold text-gray-700">Events</h2>
          <p className="text-2xl font-bold text-green-600">58</p>
        </div>
        <div className="bg-white shadow-md rounded-lg p-4">
          <h2 className="text-lg font-semibold text-gray-700">Tickets Sold</h2>
          <p className="text-2xl font-bold text-purple-600">4,320</p>
        </div>
        <div className="bg-white shadow-md rounded-lg p-4">
          <h2 className="text-lg font-semibold text-gray-700">Revenue</h2>
          <p className="text-2xl font-bold text-red-600">$12,450</p>
        </div>
      </div>
    </Layout>
  );
}
